import { render, staticRenderFns } from "./equipeDetalhe.vue?vue&type=template&id=46db28bf&scoped=true&"
import script from "./equipeDetalhe.vue?vue&type=script&lang=js&"
export * from "./equipeDetalhe.vue?vue&type=script&lang=js&"
import style0 from "./equipeDetalhe.vue?vue&type=style&index=0&id=46db28bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46db28bf",
  null
  
)

export default component.exports